import React from 'react';
import ZitoneoHeader from './ZitoneoHeader';
import { Switch } from 'react-router-dom';
import { ProviderHotelsList } from '../contexts/HotelsListContext';
import ProtectedRoute from '../../../utils/ProtectedRoute';
import { ProviderZitoneoContent } from '../contexts/ZitoneoContentContext';
import { ProviderZitoneoUI } from '../contexts/ZitoneoUIContext';
import { ProviderZitoneoImages } from '../contexts/ZitoneoImagesContext';
import ZitoneoServices from '../hotelContent/detail/ZitoneoServices';
import {
    AppSections,
    AppSectionsZitoneo,
} from '../../../types/appConfiguration/appConfigTypes';
import HotelsContentList from '../hotelContent/list/HotelsContentList';
import HotelPresentation from '../hotelContent/presentation/HotelPresentation';
import { zitoneoRouteDefinitions } from '../utils/zitoneoRoutes';

const ZitoneoApp = () => {
    return (
        <ProviderZitoneoUI>
            <ProviderZitoneoContent>
                <ProviderZitoneoImages>
                    <ProviderHotelsList>
                        <main className='flex-column flex-grow width100perc overflow-hidden '>
                            <ZitoneoHeader />
                            <Switch>
                                <ProtectedRoute
                                    exact
                                    path={
                                        zitoneoRouteDefinitions.HOTEL_PRESENTATION
                                    }
                                    render={() => <HotelPresentation />}
                                    section={AppSections.ZITONEO}
                                    page={AppSectionsZitoneo.HOTEL_CONTENT}
                                />
                                <ProtectedRoute
                                    path={zitoneoRouteDefinitions.HOTEL_CONTENT}
                                    render={() => <ZitoneoServices />}
                                    section={AppSections.ZITONEO}
                                    page={AppSectionsZitoneo.HOTEL_CONTENT}
                                />
                                <ProtectedRoute
                                    path={
                                        zitoneoRouteDefinitions.HOTELS_CONTENT_LIST
                                    }
                                    render={() => <HotelsContentList />}
                                    section={AppSections.ZITONEO}
                                    page={AppSectionsZitoneo.HOTEL_CONTENT}
                                />
                            </Switch>
                        </main>
                    </ProviderHotelsList>
                </ProviderZitoneoImages>
            </ProviderZitoneoContent>
        </ProviderZitoneoUI>
    );
};

export default ZitoneoApp;
